import { render, staticRenderFns } from "./DCOPreviewSelector.vue?vue&type=template&id=15d20be5&scoped=true"
import script from "./DCOPreviewSelector.vue?vue&type=script&lang=js"
export * from "./DCOPreviewSelector.vue?vue&type=script&lang=js"
import style0 from "./DCOPreviewSelector.vue?vue&type=style&index=0&id=15d20be5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d20be5",
  null
  
)

export default component.exports